module.exports = __webpack_public_path__ + "img/device_cb03.cdb9dfd0.png";